(function ($) {
  DJ.addBehavior('filterSort', '.filter-speciality-sort', {
    attach: function () {
      const filterSort = this;
      const sortSelect = filterSort.querySelector('select');
      let realSortSelectWrapper = document.querySelector('.tiles__inner-wrapper-desktop .filter-speciality .js-form-item-sort-by');
      let submitButton = document.querySelector('.tiles__inner-wrapper-desktop .filter-speciality .filter-speciality__popin-form-button-submit');

      if (DJ.bp.name === 'mobile') {
        realSortSelectWrapper = document.querySelector('.tiles__inner-wrapper-mobile .filter-speciality .js-form-item-sort-by');
        submitButton = document.querySelector('.tiles__inner-wrapper-mobile .filter-speciality .filter-speciality__popin-form-button-submit');
      }

      /**
       * Return false if no select.
       */
      if (!sortSelect || !realSortSelectWrapper || !submitButton) {
        return false;
      }

      const realSortSelect = realSortSelectWrapper.querySelector('select');
      const realSortLabel = realSortSelectWrapper.querySelector('label');
      const sortSelectLabel = filterSort.querySelector('label');

      if (realSortLabel && sortSelectLabel) {
        sortSelectLabel.innerHTML = realSortLabel.innerHTML;
      }

      sortSelect.innerHTML = realSortSelect.innerHTML;
      filterSort.classList.remove('filter-speciality-sort--hidden');

      jcf.replace(sortSelect, 'Select', {
        wrapNative: false,
        fakeDropInBody: false
      });

      const selectChange = () => {
        realSortSelect.value = sortSelect.value;
        submitButton.click();
      };

      sortSelect.addEventListener('change', selectChange);

      sortSelect.addEventListener('keydown', (e) => {
        realSortSelect.value = sortSelect.value;

        if (e.keyCode === 38 || e.keyCode === 40) {
          sortSelect.removeEventListener('change', selectChange);
        }

        if (e.keyCode === 13 && !filterSort.querySelector('.jcf-drop-active')) {
          submitButton.click();
        }

        setTimeout(() => {
          sortSelect.addEventListener('change', selectChange);
        }, 1);
      });

      return true;
    }
  });
})(jQuery);
